// Seeded pseudo random numbers (mulberry32). Every random decision of the simulation goes through an Rng
// owned by the world, so a session can be replayed from its seed and the command log.
export class Rng {
  private s: number;
  constructor(seed: number) { this.s = seed >>> 0 || 0x9e3779b9; }
  next(): number {
    let t = (this.s = (this.s + 0x6d2b79f5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  range(lo: number, hi: number): number { return lo + (hi - lo) * this.next(); }
  int(lo: number, hi: number): number { return Math.floor(this.range(lo, hi + 1)); }
  chance(p: number): boolean { return this.next() < p; }
  pick<T>(arr: readonly T[]): T {
    if (!arr.length) throw new Error('pick from empty array');
    return arr[Math.floor(this.next() * arr.length)]!;
  }
  weighted<T>(items: readonly T[], weight: (t: T) => number): T {
    const total = items.reduce((s, i) => s + Math.max(0, weight(i)), 0);
    let r = this.next() * total;
    for (const i of items) { r -= Math.max(0, weight(i)); if (r < 0) return i; }
    return items[items.length - 1]!;
  }
  /** Normally distributed value (Box–Muller). */
  normal(mean = 0, sd = 1): number {
    const u = Math.max(1e-12, this.next()), v = this.next();
    return mean + sd * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  }
  fork(salt: number): Rng { return new Rng((this.next() * 4294967296) ^ salt); }
}

/** Stable 32-bit hash of a string (FNV-1a), e.g. to give each callsign its own voice. */
export function hashStr(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0;
}
